import React, { FC, Ref, CSSProperties, useState, useEffect } from 'react';
import cn from 'classnames';
require("./ProgressBar.css");
var styles = {
  "Root": "ProgressBar-module-Root_17U",
  "Step": "ProgressBar-module-Step_2U_",
  "current": "ProgressBar-module-current_2XT",
  "Indicator": "ProgressBar-module-Indicator_1pK"
};
export const ProgressBar = ({
  amountSteps = 4,
  className,
  controlRef,
  currentStepIndex = 1,
  innerRef,
  style
}) => {
  const [width, setWidth] = useState(100 / (Number(amountSteps) - 1) * (currentStepIndex - 1));
  useEffect(() => {
    setWidth(100 / (Number(amountSteps) - 1) * (currentStepIndex - 1));
  }, [amountSteps, currentStepIndex]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef,
    "aria-hidden": "true"
  }, currentStepIndex > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles.Indicator,
    style: {
      width: `calc(${width}% - 1px)`
    }
  }), Array.from(Array(Number(amountSteps)).keys()).map((step, i) => /*#__PURE__*/React.createElement("div", {
    key: step,
    className: cn(styles.Step, {
      [styles.current]: i + 1 === currentStepIndex
    })
  })));
};
if (process.env.NODE_ENV !== 'production') {
  ProgressBar.displayName = 'ProgressBar';
}